<div *ngIf="(isOngoing$ | async) === true">
    <p>Submitting batch correction to Tracy. {{ percentCompleted$ | async | percent }} completed...</p>
</div>
<div *ngIf="(isOngoing$ | async) === false">
    <p>Resubmission completed.</p>
    <p *ngIf="completedCorrections$ | async as completedCorrections"><strong>{{ completedCorrections.length }}</strong>
        resubmissions succeeded.</p>
    <p *ngIf="failedCorrections$ | async as failedCorrections"><strong>{{ failedCorrections.length }}</strong>
        resubmissions failed.</p>
</div>